<template>
    <div class="main">
        <Header></Header>
        <div class="page-body wrap fix">
            <div class="l">
                <SideBar></SideBar>
            </div>
            <div class="r">
                <router-view />
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
    import Header from './header'
    import Footer from './footer'
    import SideBar from './side-bar'
    export default {
        name: 'Main',
        components: {
            Header,
            Footer,
            SideBar
        },
        data () {
            return {}
        }
    }
</script>

<style scoped>
    .page-body{
        padding-top: 20px;
    }
</style>
